<!--课桌管理-->
<template>
  <div class="deskManage-container">
    <div class="deskManage-main flex">
      <main-left only-school @treeNodeClick="treeNodeClick" />
      <div class="deskManage-right flex_1 div-layout">
        <module-title title="课桌列表" />
        <div class="deskManage-right-contain">
          <p>{{ clickTreeData.name }}</p>
          <div class="machineManage-search">
            <el-form :model="searchForm" :inline="true" label-position="right" label-width="100px">
              <div>
                <!-- <el-form-item label="设备ID：" prop="teacherName">
                  <el-input
                    v-model="searchForm.teacherName"
                    name="teacherName"
                    auto-complete="off"
                    size="medium"
                    placeholder="请输入标题"
                    class="form-input"
                    clearable
                  />
                </el-form-item> -->
                <el-form-item label="所属楼栋：" prop="buildingId">
                  <el-select v-model="searchForm.buildingId" placeholder="请选择" class="form-input" @change="handleChangeBuilding">
                    <el-option label="全部" value="" />
                    <el-option
                      v-for="item in selectOptions.buildingOption"
                      :key="item.buildingId"
                      :label="item.name"
                      :value="item.buildingId"
                      class="form-input"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="所属楼层：" prop="floor">
                  <el-select v-model="searchForm.floor" placeholder="请选择" class="form-input" @change="handleChangeFloor">
                    <el-option label="全部" value="" />
                    <el-option
                      v-for="item in selectOptions.floorOption"
                      :key="item.floorName"
                      :label="item.name"
                      :value="item.floorName"
                      class="form-input"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="所属教室：" prop="roomId">
                  <el-select v-model="searchForm.roomId" placeholder="请选择" class="form-input">
                    <el-option label="全部" value="" />
                    <el-option
                      v-for="item in selectOptions.roomOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      class="form-input"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-left:20px;">
                  <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
                    查询
                  </el-button>
                </el-form-item>
              </div>
            </el-form>
            <el-table
              v-loading="listLoading"
              :data="deskList"
              fit
              highlight-current-row
              element-loading-text="Loading"
            >
              <!-- <el-table-column type="selection" width="55" align="center"/> -->
              <el-table-column label="序号" align="center" type="index" width="55" />
              <el-table-column label="设备ID" prop="id" align="center" />
              <el-table-column label="所属楼栋" prop="buildingName" align="center" />
              <el-table-column label="所属楼层" prop="floor" align="center">
                <template slot-scope="scope">
                  {{ scope.row.floor }}楼
                </template>
              </el-table-column>
              <el-table-column label="所属教室" prop="roomName" align="center" />
              <el-table-column label="MAC地址" prop="mac" align="center" width="150px" />
              <el-table-column label="启用时间" align="center" width="150px">
                <template slot-scope="scope">
                  {{ scope.row.enableTime | formatDate }}
                </template>
              </el-table-column>
              <el-table-column label="操作" prop="op" align="center" width="150px">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-info"
                    @click="handleDetail(scope.row)"
                  >
                    详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination
              :total="pageObj.total"
              :page.sync="pageObj.currentPage"
              :limit.sync="pageObj.pageSize"
              @pagination="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            />
          </div>
        </div>
      </div>
    </div>
    <!--详情-->
    <el-dialog
      v-if="hiddenVariable.dialogDetailVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogDetailVisible"
      title="查看详情"
      width="720px"
      class="detail-container"
    >
      <p class="status-title">
        基本信息
      </p>
      <div class="manager-info">
        <ul class="fl">
          <li>
            <label>设备ID：</label>
            {{ detailObj.id }}
          </li>
          <li>
            <label>所属机构：</label>
            {{ detailObj.orgName }}
          </li>
          <li>
            <label>所属楼层：</label>
            {{ detailObj.floor }}
          </li>
          <li>
            <label>座位信息：</label>
            {{ detailObj.roomRow }}行{{ detailObj.roomCol }}座
          </li>
        </ul>
        <ul class="fl">
          <li>
            <label>设备类型：</label>
            {{ detailObj.deskType }}
          </li>
          <li>
            <label>所属楼层：</label>
            {{ detailObj.floor }}楼
          </li>
          <li>
            <label>所属教室：</label>
            {{ detailObj.roomName }}
          </li>
          <li>
            <label>授权码：</label>
            {{ detailObj.authCode }}
          </li>
        </ul>
      </div>
      <el-divider />
      <p class="status-title">
        参数信息
      </p>
      <div class="manager-info">
        <ul>
          <li>
            <label>设备型号：</label>
            {{ detailObj.model }}
          </li>
          <li>
            <label>系统版本号：</label>
            {{ detailObj.sysVersion }}
          </li>
          <li>
            <label>批次号：</label>
            {{ detailObj.batchNum }}
          </li>
        </ul>
        <ul>
          <li>
            <label>启用时间：</label>
            {{ detailObj.enableTime | formatDate }}
          </li>
          <li>
            <label>软件版本号：</label>
            {{ detailObj.sysVersion }}
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DeskInfo from '@/api/systemMaintenance/devicManage/deskInfo';
import { formatTimeToStr, noSchoolMessage } from '@/utils/index';
import { queryTeachingBuilding, getFloorByBuilding, queryClassroom } from '@/api/systemMaintenance/devicManage/common';
export default {
  name: 'DeskManage',
  filters: {
    formatDate: function(time) {
      return formatTimeToStr(time, 'yyyy-MM-dd');
    }
  },
  data() {
    return {
      searchForm: {
        buildingId: '',
        floor: '',
        roomId: ''
      },
      selectOptions: {
        buildingOption: [], // 教学楼
        floorOption: [], // 楼层下拉
        roomOption: [] // 教室下拉
      },
      // 分页参数
      pageObj: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      hiddenVariable: {
        dialogDetailVisible: false // 详情
      },
      deskList: [],
      listLoading: false,
      // 详情
      detailObj: {},
      // 树点击对象
      clickTreeData: {} // 机构树
    };
  },
  methods: {
    handleSizeChange(obj) {
      this.pageObj.currentPage = 1;
      this.pageObj.pageSize = obj.limit;
      this.queryDesks();
    },
    handleCurrentChange(obj) {
      this.pageObj.currentPage = obj.page;
      this.pageObj.pageSize = obj.limit;
      this.queryDesks();
    },
    // 点击机构数
    treeNodeClick(data) {
      this.clickTreeData = data;
      this.queryDesks();
      this.queryTeachingBuildingFn();
      this.clearSearch();
    },
    // 条件查询
    handleSearchFilter() {
      this.pageObj.currentPage = 1;
      this.pageObj.pageSize = 10;
      this.queryDesks();
    },
    clearSearch() {
      this.searchForm = {
        buildingId: '',
        floor: '',
        roomId: ''
      };
    },
    // 资源查询
    queryDesks() {
      // 机构下没有学校则报错
      if (!noSchoolMessage.call(this, this.clickTreeData.code)) {
        return;
      }
      this.deskList = [];
      this.listLoading = true;
      DeskInfo.queryDesks({
        pageNum: this.pageObj.currentPage,
        pageSize: this.pageObj.pageSize,
        orgCode: this.clickTreeData.code, // 学校code
        ...this.searchForm // 搜索条件
      }).then(response => {
        this.listLoading = false;
        const data = response.data;
        if (data) {
          this.deskList = data.list;
          this.pageObj.total = data.total;
        } else {
          this.deskList = [];
          this.pageObj.total = 0;
        }
      }).catch(error => {
        this.listLoading = false;
        console.log(error);
      });
    },

    // 查看详情
    handleDetail(row) {
      this.hiddenVariable.dialogDetailVisible = true;
      this.detailObj = row;
      // DeskInfo.queryDeskDetail({
      //   id: row.id
      //   // schoolCode: this.clickTreeData.code, // 学校code
      // }).then(response => {
      //   this.detailObj = response.data;
      // }).catch(error => {
      //   console.log(error);
      // });
    },
    // 查询教学楼下拉
    queryTeachingBuildingFn(reqOption) {
      const self = this;
      queryTeachingBuilding({
        'params': {
          pageNum: 1,
          pageSize: 999,
          schoolCode: this.clickTreeData.code // 学校code
        },
        callBack(resp) {
          self.searchForm.floor = '';
          self.searchForm.roomId = '';
          self.selectOptions.buildingOption = resp;
        }
      });
    },
    // 教学楼下拉选择
    handleChangeBuilding(val) {
      this.selectOptions.floorOption = getFloorByBuilding(val, this.selectOptions.buildingOption);
      this.searchForm.floor = '';
      this.searchForm.roomId = '';
    },
    // 楼层下拉
    handleChangeFloor() {
      const self = this;
      queryClassroom({
        params: {
          pageNum: 1,
          pageSize: 999,
          schoolCode: this.clickTreeData.code, // 学校code
          buildingId: this.searchForm.buildingId,
          floorName: this.searchForm.floor
        },
        callBack(resp) {
          self.selectOptions.roomOption = resp.list;
          self.searchForm.roomId = '';
        }
      });
    }

  }
};
</script>
<style lang="scss" scoped>
.deskManage-container {
  .deskManage-main {
    min-height: 80vh;
    padding-bottom: 20px;
    .deskManage-right {
      .deskManage-right-contain {
        > p {
          padding-left: 25px;
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          margin-bottom: 20px;
        }
      }
    }
  }
}
.manager-info {
  display: flex;
  ul {
    margin-left: 50px;
    max-width: 350px;
    flex: 1;
    li {
      margin-bottom: 20px;
    }
  }
}
.detail-container {
  .status-title {
    padding-left: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #666666;
    margin-bottom: 20px;
  }
}
</style>
